import {ViewStream, DomElement} from 'spyne';
import BlogArticleTmpl from './templates/blog-article.tmpl.html';
import {PageBlogArticleBlock} from 'components/ui/page-blog-article-block';
import {UtilTraits} from 'traits/util-traits';

// Renders one blog article from data (blog-data.json → articles[n]):
// the shell (title, subtitle, meta row) binds from article.meta, and each
// entry in article.content renders as a bl* block (PageBlogArticleBlock).
export class PageBlogArticleView extends ViewStream {

    constructor(props={}) {
        props.class = 'blog-article';
        props.template = BlogArticleTmpl;
        props.channels = [["CHANNEL_ROUTE", true], 'CHANNEL_UI'];

        const article = props.data ?? {};
        const meta = article.meta ?? {};
        props.articleContent = article.content ?? [];
        props.data = meta;

        if (meta.titleId === undefined || meta.titleId === '') {
          meta.titleId = UtilTraits.util$ToKebabCase(
              String(meta.title ?? '').replace(/<[^>]+>/g, ''),
          );
        }

      super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [
          ["CHANNEL_UI_CLICK_EVENT", "onBlogAnchorLinkCLicked", '.blog-anchor-link'],
          ["CHANNEL_ROUTE_CHANGE_EVENT", "disposeViewStream"]

        ];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [
            ['a:not(.external)', 'click']
        ];
    }

  addArticleBlocks() {
    const addBlock = (data) => {
      this.appendView(new PageBlogArticleBlock({ data }), '.blog-blocks');
    };

    this.props.articleContent.forEach(addBlock);
  }

  onBlogAnchorLinkCLicked(e){
      const {url} = e.payload;

      const toastEl$ = this.props.el$("#copy-toast");


    // Helper to show toast
    const showToast = () => {
      //console.log("TOAST EL ",toastEl$);

      if (toastEl$.exists === false){
        return;
      }

      let toast = toastEl$.el;



      toast.classList.add('visible');
      // Clear any existing timer to prevent flickering if clicked rapidly
      clearTimeout(toast.timer);
      toast.timer = setTimeout(() => {
        toast.classList.remove('visible');
      }, 2000); // Hide after 2 seconds
    };

     navigator.clipboard.writeText(url).then(() => {
      // Optional: Show a "Copied!" toast here
       showToast();
      //console.log('Link copied:', url);
    });
  }


  addAnchorLinks() {
    // Select all headers inside the blog article that have IDs
    const headers = this.props.el$('article.blog h2[id], article.blog h3[id]').arr;
    //console.log("headers", headers);
    headers.forEach(header => {
      // Create the anchor link element

      let toastEl$ = this.props.el$('#copy-toast');
      if (toastEl$.exists === false) {

        const toastEl = new DomElement({
          id: "copy-toast",
          data: "copied",
          class: "copy-notification"
        })

        this.props.el.appendChild(toastEl.render());
      }




      const link = document.createElement('a');
      link.className = 'anchor-link blog-anchor-link';
      link.href = `#${header.id}`;
      link.textContent = '#'; // Or use an SVG icon here
      link.title = 'Link to this section';
      link.dataset.eventPreventDefault = true;
      const url = window.location.origin + window.location.pathname + '#' + header.id;
      link.dataset.url = url;

      // Prepend the link to the header
      header.prepend(link);
    });
  }


  scrollToHash() {
    // 1. Get the hash from the URL (e.g., "#my-section")
    const hash = window.location.hash;

    // 2. Check if hash exists and isn't just an empty "#"
    if (hash && hash.length > 1) {
      try {
        // 3. Remove the '#' and decode the string (handles special chars like spaces/%20)
        const id = decodeURIComponent(hash.substring(1));

        // 4. Find the element by ID
        const el$ = this.props.el$(`#${id}`);


        if (el$.exists) {
          // 5. Scroll into view with smooth animation

          const element = el$.el;
          const offset = 96;

          // 2. Get the element's distance from the top of the viewport
          const elementPosition = element.getBoundingClientRect().top;

          // 3. Get the current scroll position
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      } catch (e) {
        console.warn("Could not scroll to hash:", e);
      }
    }
  }


    onRendered() {

      //console.log("RENDERED BLOG ARTICLE ",this.props.el);
      this.addArticleBlocks();
      this.addAnchorLinks();
      // Re-run as images/figures load and shift the target's position —
      // scrollToHash is a no-op when there is no hash.
      const scrollToHash = this.scrollToHash.bind(this);
      window.setTimeout(scrollToHash, 300);
      window.setTimeout(scrollToHash, 1500);
      window.setTimeout(scrollToHash, 3200);
    }

}
